export function Group(props) {
  const { visible, children, classList } = props;

  if (visible === false) {
    return null;
  }

  return (
    <div className={`Group ${classList}`}>
      { children }
    </div>
  )
}

export default Group;